import cx from 'classnames'

import { useTranslate } from '../../hooks/useTranslate'

type Props = {
  className?: string
  // The name of the items in the list. Should be in plural form for lists.
  itemName?: string
  // The reason why the list is empty.
  reason?: string
  variant?: 'standAlone' | 'tableCaption'
}

export const EmptyState = ({
  className,
  itemName,
  reason,
  variant = 'standAlone',
}: Props) => {
  const translate = useTranslate()
  const itemsText = itemName ?? translate('emptyState.items')
  const emptyStateText = translate('emptyState.noItems', {
    itemName: itemsText,
  })

  return (
    <div
      className={cx(
        'text-center font-bold text-gray-300',
        {
          'py-5 text-lg': variant === 'standAlone',
          'py-2': variant === 'tableCaption',
        },
        className,
      )}
    >
      <div
        className={cx({
          'text-xl': variant === 'standAlone',
          'text-lg': variant === 'tableCaption',
        })}
      >
        {emptyStateText}
      </div>
      {reason && (
        <div className="text-gray-300 dark:text-gray-400">{reason}</div>
      )}
    </div>
  )
}
